import { EffectCallback, useEffect } from "react";

const useOnMount = (onMount: EffectCallback) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(onMount, []);
};

export default useOnMount;
